module.exports = __webpack_public_path__ + "img/202505_05.971200a9.jpg";